<template>
  <div class="sheets">
    <button class="print-button pure-button" @click="print">印刷</button>
    <section class="sheet">
      <div class="property">
        <span class="name">{{ name }}</span><span>{{ ym }}</span>
      </div>
      <div class="tables" ref="tables">
        <table>
          <tr v-for="(image, index) in imagesLeft" :key="index">
            <td class="td-image">
              <img class="image" :src="image" />
            </td>
          </tr>
        </table>
        <table>
          <tr v-for="(image, index) in imagesRight" :key="index">
            <td class="td-image">
              <img class="image" :src="image" />
            </td>
          </tr>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import moment from "moment"

export default {
  data() {
    return {
      ym: this.$route.query.month,
      name: this.$route.query.name,
      images: []
    }
  },

  created() {
    this.getImages()
  },

  computed: {
    imagesLeft() {
      return this.images.filter((_, index) => {
        return index % 8 < 4
      })
    },

    imagesRight() {
      return this.images.filter((_, index) => {
        return 4 <= index % 8
      })
    }
  },

  methods: {
    getImages() {
      this.$http.get("/transport_image_data", {
        params: {
          month: moment(this.$route.query.month).format('YYYY-MM'),
          id: this.$route.query.id
        }
      })
      .then(res => {
        res.data.images.forEach(image => {
          let imageType = 'image/png'
          let base64 = 'data:' + imageType + ';base64, ' + image

          var image = new Image()

          image.src = base64

          image.onload = () => {
            // 画像整形用のcanvas用意
            var canvas = document.createElement('canvas')
            var ctx = canvas.getContext('2d')

            if (image.width < image.height) {
              // 縦長画像の場合は横置きになるよう設定
              canvas.height = image.width
              canvas.width = image.height
              ctx.rotate(270 * Math.PI / 180)
              ctx.translate(-image.width, 0)
            } else {
              canvas.height = image.height
              canvas.width = image.width
            }

            ctx.drawImage(image, 0, 0, image.width, image.height)
            let dstBase64 = canvas.toDataURL(imageType)

            this.images.push(dstBase64)
          }
        })
      })
    },

    print() {
      window.print()
    }
  }
}
</script>

<style lang="scss" scoped>
.name {
  margin-right: 10px;
}

.tables {
  display: flex;
}

.print-button {
  margin: 20px 30px 0 auto;
  display: block;
  background: linear-gradient(135deg, #fff5ee, #83ccd2);
}

.property {
  text-align: end;
}

table {
  width: 50%;
  table-layout: fixed;  

  tr {
    page-break-inside: avoid;
  }

  // ヘッダー部分に画像が被るのを防止
  tr:nth-child(4n-3) {
    img {
      margin-top: 30px;
    }
  }

  td {
    padding: 3px;
    display: flex;
  }
}

.td-image {
  height: 64mm;
}

img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: top left;
}

/* hide in print */
@media print {
  .print-button {
    display: none;
  }

  .sheet {
    page-break-after: always;
  }

  .property {
    position: fixed;
    top: 0;
    right: 0;
  }
}

/* for preview */
@media screen {
  .sheet {
    width: 200mm;
    min-height: 296mm;
    margin: 5px auto;
    padding: 5mm;
    background: white;
    box-shadow: 0 .5mm 2mm rgba(0,0,0,.3);
  }
}
</style>

<style lang="scss">
#app {
  overflow-y: initial !important;
}

footer {
  display: none;
}

/* for preview */
@media screen {
  body {  
    background: #eee;
  }
}

@media print {
  body {
    height: auto;
  }
}
</style>